import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { computed, onUnmounted, ref, watchEffect } from 'vue';
import { buildCloudFrontUrl } from '@/utils/pathUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CPreview',
  props: {
    src: null,
    alt: { default: 'file preview' },
    thumbnail: { type: Boolean },
    hideWrapper: { type: Boolean },
    width: null,
    maxHeight: { default: '300px' },
    lazy: { type: Boolean },
    fit: null
  },
  emits: ["preview-failed"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'preview-failed'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { src: File | unknown, alt: string, thumbnail?: boolean, hideWrapper?: boolean, width?: number, maxHeight: string, lazy?: boolean, fit?: 'contain' | 'cover' };

_useCssVars((_vm, _setup) => ({
  "33e3de10": (_setup.previewWidth),
  "3e33b3d1": (_vm.maxHeight),
  "5dfc4cb7": (_vm.fit)
}))





const source = ref('');

const previewWidth = computed(() => {
    const width = props.thumbnail ? 50 : props.width;
    return `${width}px`;
});

watchEffect(() => {
    if (!props.src) return;

    if (typeof props.src == 'string') {
        source.value = props.src.startsWith('/Content') ? buildCloudFrontUrl(props.src) : props.src;
        return;
    }

    source.value = URL.createObjectURL(props.src as File);
});

onUnmounted(() => {
    //Revoke the url to avoid memory leaks.
    URL.revokeObjectURL(source.value);
});

const onErrorHandler = () => {
    emit('preview-failed');
};

return { __sfc: true,props, emit, source, previewWidth, onErrorHandler }
}

})